import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { UserIcon, DeliveryIcon } from 'cokitchen-icons';

export enum ENUM_ROASTER_SEARCH_TYPES {
  NAME = 'name',
  DEPT = 'department'
}
type Props = {
  searchVal: { type: ENUM_ROASTER_SEARCH_TYPES; val: string };
  setSearchVal: (data: Props['searchVal']) => void;
};

export const details = [
  {
    name: 'Name',
    icon: <UserIcon />,
    id: ENUM_ROASTER_SEARCH_TYPES.NAME
  },
  {
    name: 'Department',
    icon: <DeliveryIcon />,
    id: ENUM_ROASTER_SEARCH_TYPES.DEPT
  }
];

const RosterFilter = ({ setSearchVal, searchVal }: Props) => {
  const [showSearchTypeDropdown, setShowSearchTypeDropdown] = useState(false);

  const [selectedSearchType, setSelectedSearchType] = useState(details[0]);

  return (
    <div className='border border-gray-border flex items-center p-1.5 rounded-md'>
      <input
        value={searchVal.val}
        onChange={(e) => setSearchVal({ ...searchVal, val: e.target.value })}
        className='bg-transparent placeholder:text-sm pl-1 focus:outline-none'
        placeholder={`Search by ${selectedSearchType.name.toLowerCase()}`}
      />
      <Dropdown
        visible={showSearchTypeDropdown}
        content={
          <div
            onClick={() => setShowSearchTypeDropdown(!showSearchTypeDropdown)}
            className='text-gray-8 bg-gray-border cursor-pointer rounded-lg p-1.5'>
            {selectedSearchType.icon}
          </div>
        }>
        <DropdownList>
          {showSearchTypeDropdown &&
            details.map((detail) => (
              <DropdownItem
                onClick={() => {
                  setSelectedSearchType(detail);
                  setShowSearchTypeDropdown(false);
                  setSearchVal({
                    val: '',
                    type: detail.id
                  });
                }}
                buttonClassName='gap-2 py-2'
                key={`${detail.id}-${detail.name}`}>
                <span className='text-gray-8'>{detail.icon}</span>
                {detail.name}
              </DropdownItem>
            ))}
        </DropdownList>
      </Dropdown>
    </div>
  );
};

export default RosterFilter;
